// src/pages/Video/VideoIdRedirect.tsx
import { useParams, Navigate } from 'react-router-dom';
import { useAppSelector } from '@/store/hooks';
import { selectVideoById } from '@/features/videos/videosSlice';

export function VideoIdRedirect() {
    const { id } = useParams();
    const video = useAppSelector(selectVideoById(id));
    if (!video) return <Navigate to="/videos" replace />;
    return <Navigate to={`/videos/${video.slug}`} replace />;
}